
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import HamburgerButton from "./HamburgerMenuButton/HamburgerButton";
import axiosInstance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { LuChevronDown, LuChevronRight } from "react-icons/lu";
// import icons from '../../public/iconApi.svg'
const Sidebar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const [walletData, setWalletData] = useState(null);
  const [sessionToken, setSessionToken] = useState(null);
  const [partnerCode, setPartnerCode] = useState(null);
  const [userName, setUserName] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false); // State to track admin role
  const [isPartner, setIsPartner] = useState(false); // State to track partner role
  const [isPayaspergo, setIsPayaspergo] = useState(false); // State to track partner role
  const [isfinance, setIsfinance] = useState(false); // State to track partner role
    const [isstore, setIssupport] = useState(false); // State to track partner role
        const [ispwg, setIspwg] = useState(false); // State to track partner role
        const [isSubReseller, setIsSubReseller] = useState(false); // State to track sub-reseller role
        const [isSubSupport, setIsSubSupport] = useState(false); // State to track sub-reseller role
        const [isSubFinance, setIsSubFinance] = useState(false); // State to track sub-reseller role
  const [isstoredPartnerCode, setIsstoredPartnerCode] = useState(false); // State to track partner role
  const [isstoredPartnerCodemanual, setIsstoredPartnerCodemanual] =useState(false)
  const [userRole, setUserRole] = useState(null); // State for user role
  const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable
  const navigate = useNavigate();
 /**
 * Rules for defining menu items
 * 
 * If the menu item has children then the path of that item becomes redundant and on clicking
 * that item a dropdown will appear to show the child items.
 * 
 * Each child items should have these three properties
 * path, title icon
 
 * Giving children attributes to child items is not allowed(i.e nesting level more than one is not allowed)
 * 

 */
  useEffect(() => {
    const fetchSessionData = () => {
      const storedSessionToken = localStorage.getItem("token");
      const storedPartnerCode = localStorage.getItem("partnerCode");
      const storedUserName = localStorage.getItem("Name");
      const storedRole = localStorage.getItem("role"); // Fetch user role

      if (
        storedSessionToken &&
        storedPartnerCode &&
        storedUserName &&
        storedRole
      ) {
        setSessionToken(storedSessionToken);
        setPartnerCode(storedPartnerCode);
        setUserName(storedUserName);
        setIsAdmin(storedRole === "admin"); // Check if user is admin
        setIsPartner(storedRole === "Partner"); // Check if user is partner
        setIsPayaspergo(storedRole === "Payaspergo"); // Check if user is partner
        setIsfinance(storedRole === "finance"); // Check if user is partner
        setIssupport(storedRole === "support"); // Check if user is partner
        setIspwg(storedRole === "pwg"); // Check if user is partner
        setIsSubReseller(storedRole === "Sub_Reseller"); // Check if user is partner
        setIsSubSupport(storedRole === "Sub_Support"); // Check if user is partner
        setIsSubFinance(storedRole === "Sub_Finance"); // Check if user is partner

        setIsstoredPartnerCode(
          storedPartnerCode == 148497128 || 
          storedPartnerCode == 228025162 || 
          storedPartnerCode == 228272131 || 
          storedPartnerCode == 12246289 
          );
            setIsstoredPartnerCodemanual(
          storedPartnerCode == 112722282 || 
          storedPartnerCode == 34518854
          );
              } else {
        navigate("/");
      }
    }; 
    fetchSessionData();
  }, [navigate]);

  // useEffect(() => {
  //   const fetchWalletData = async () => {
  //     const sessionToken = localStorage.getItem("token");
  //     const partnerCode = localStorage.getItem("partnerCode");

  //     try {
  //       if (!sessionToken || !partnerCode) {
  //         console.error(
  //           "Session token or partner code missing",
  //           sessionToken,
  //           partnerCode
  //         );
  //         return;
  //       }

  //       // const response = await axiosInstance.get(
  //       //   `ESIMGOPartner/get_wallet_invidual`,
  //       //   {
  //       //     params: {
  //       //       partnercode: partnerCode,
  //       //     },
  //       //   }
  //       // );
  //       // setWalletData(response.data.getindividualwallet[0]);
  //     } catch (error) {
  //       console.error("Error fetching wallet data:", error);
  //     }
  //   };

  //   fetchWalletData();
  // }, [sessionToken, partnerCode]);

  const firstMenuItems = [
    // { title: 'Dashboard', path: '/Home', icon: '/icons.svg' },
    // { title: 'eSIMs Store', path: '/EsimStore', icon: '/icons1.svg' },
    // { title: 'Transaction History', path: '/Transactions', icon: '/icons6.svg' },
    // { title: 'Wallet Top-Up', path: '/TopUps', icon: '/icons3.svg' },
    // { title: 'News & Updates', path: '/News', icon: '/icons4.svg' },
  ];

  if (isAdmin) {
    firstMenuItems.push(
      { title: "Dashboard", path: "/SuperadminDashboard", icon: "/icons.svg" },
      { title: "Manage Partner", path: "/Superadmin", icon: "/icons6.svg" },
            { title: "All Trans", path: "/Superadmintrasn", icon: "/icons6.svg" },
      { title: "eSIMs Store", path: "/BuyPremiumplan", icon: "/icons1.svg" },

      
    );
  }
   if (isstore) {
    firstMenuItems.push(
      { title: "Dashboard", path: "/SuperadminDashboard", icon: "/icons.svg" },
      // { title: "Manage Partner", path: "/Superadmin", icon: "/icons6.svg" },
      // { title: "Manage Partner", path: "/Superadmin", icon: "/icons6.svg" },
      { title: "eSIMs Store", path: "/EsimStore", icon: "/icons1.svg" },

      // {title: "Create Partner",path: "/SuperadminPartner",icon: "/icons2.svg",},
      // {title: "SuperadminUpdate List ",path: "/SuperadminVendor",icon: "/icons5.svg",},
      // { title: "Partner Update ", path: "/Superadminpay", icon: "/icons1.svg" },
      { title: "API Box", path: "/ApiBox", icon: "/iconApi.svg" },
      { title: "Tickets", path: "/SuperadminTicket", icon: "/icons7.svg" },
                  {title: "Plan Topup/Renewal",path: "/SuperadminRenewal",icon: "/icons8.svg",},

      // { title: "Vendor Lists", path: "/SuperadminUpdate", icon: "/icons4.svg" },
    );
  }
  if (isfinance) {
    firstMenuItems.push(
      { title: "Dashboard", path: "/SuperadminDashboard", icon: "/icons.svg" },
      { title: "Manage Partner", path: "/Superadmin", icon: "/icons6.svg" },
            { title: "All Trans", path: "/Superadmintrasn", icon: "/icons6.svg" }

      // {title: "Create Partner",path: "/SuperadminPartner",icon: "/icons2.svg",},
      // {title: "SuperadminUpdate List ",path: "/SuperadminVendor",icon: "/icons5.svg",},
      // { title: "Partner Update ", path: "/Superadminpay", icon: "/icons1.svg" },
      // { title: "API Box", path: "/ApiBox", icon: "/iconApi.svg" },
      // { title: "Tickets", path: "/SuperadminTicket", icon: "/icons7.svg" },
      // { title: "Vendor Lists", path: "/SuperadminUpdate", icon: "/icons4.svg" },
    );
  }
  if (ispwg) {
    firstMenuItems.push(
      { title: "Dashboard", path: "/SuperadminDashboard", icon: "/icons.svg" },
                       {title: "PWG Cdr",path: "/Cdrtable",icon: "/icons8.svg",},


      // {title: "Create Partner",path: "/SuperadminPartner",icon: "/icons2.svg",},
      // {title: "SuperadminUpdate List ",path: "/SuperadminVendor",icon: "/icons5.svg",},
      // { title: "Partner Update ", path: "/Superadminpay", icon: "/icons1.svg" },
      // { title: "API Box", path: "/ApiBox", icon: "/iconApi.svg" },
      // { title: "Tickets", path: "/SuperadminTicket", icon: "/icons7.svg" },
      // { title: "Vendor Lists", path: "/SuperadminUpdate", icon: "/icons4.svg" },
    );
  }
  if (isSubReseller) {

    firstMenuItems.push(
      { title: "Dashboard", path: "/DefaultDashboard", icon: "/icons1.svg" },

      { title: "eSIMs Store", path: "/EsimStore", icon: "/icons1.svg" },

     {title: "Purchase History",path: "/SimMangement",icon: "/icons8.svg"},

      { title: "Transactions", path: "/Transactions", icon: "/icons6.svg" },

      { title: "Wallet Top-Up", path: "/AddmoreBalance", icon: "/icons3.svg" },

           { title: "API Box", path: "/ApiBox", icon: "/iconApi.svg" },
      { title: "Help & Support", path: "/HelpSupport", icon: "/iconhelp.svg" },
   {title: "Create Ticket", path: "/CreateTicket", icon: "/icons2.svg" },


    );

  }
  if (isSubSupport) {

    firstMenuItems.push(

      { title: "Dashboard", path: "/DefaultDashboard", icon: "/icons1.svg" },

     {title: "Purchase History",path: "/SimMangement",icon: "/icons8.svg"},

      { title: "Help & Support", path: "/HelpSupport", icon: "/iconhelp.svg" },

   {title: "Create Ticket", path: "/CreateTicket", icon: "/icons2.svg" },

    );
  }

  
  if (isSubFinance) {

    firstMenuItems.push(

      { title: "Dashboard", path: "/DefaultDashboard", icon: "/icons1.svg" },
     {title: "Purchase History",path: "/SimMangement",icon: "/icons8.svg"},
    { title: "Transactions", path: "/Transactions", icon: "/icons6.svg" },
      { title: "Wallet Top-Up", path: "/AddmoreBalance", icon: "/icons3.svg" },
   {title: "Create Ticket", path: "/CreateTicket", icon: "/icons2.svg" },

    );
  }

  if (isPartner && isstoredPartnerCode) {
    // Menu items for stored partners
    firstMenuItems.push(
      { title: "Dashboard", path: "/Home", icon: "/icons.svg" },
      { title: "eSIMs store", path: "/BuyUKplan", icon: "/icons1.svg" },
     {title: "Purchase History",path: "/SimMangement",icon: "/icons8.svg"},
      { title: "Transactions", path: "/Transactions", icon: "/icons6.svg" },
      { title: "Wallet Top-Up", path: "/AddmoreBalance", icon: "/icons3.svg" },
      {title: "Top-Up/Renew History",path: "/BuyTopupHistory",icon: "/icons8.svg"},

    );
  } else if (isstoredPartnerCodemanual) {
    // Menu items for general partners (when isstoredPartnerCode is false)
    firstMenuItems.push(
      { title: "Dashboard", path: "/Home", icon: "/icons.svg" },
      { title: "eSIMs Store", path: "/EsimStore", icon: "/icons1.svg" },
      {title: "Purchase History",path: "/SimMangement",icon: "/icons8.svg"},
      { title: "Wallet Top-Up", path: "/AddmoreBalance", icon: "/icons3.svg" },
      { title: "Transactions", path: "/Transactions", icon: "/icons6.svg" },
           {title: "Manual Histroy",path: "/ExcelViewer",icon: "/icons8.svg"},
     {title: "Top-Up/Renew Histroy",path: "/BuyTopupHistory",icon: "/icons8.svg"},
          //  { title: "Offline Purchase ", path: "/ExcelViewer", icon: "/icons9.svg" },
//       { title: "Manage Partner", path: "/Superadmin", icon: "/icons6.svg" },
// {title: "Purchase Details",path: "/SuperadminWallet",icon: "/icons8.svg",},
//             {title: "Plan Topup/Renewal",path: "/SuperadminRenewal",icon: "/icons8.svg",},

      


      {
        title: "Create Your Custom Plan",
        path: "/InventoryVendor",
        icon: "/icons1.svg",
        children: [
          { title: "Add Your Vendor", path: "/InventoryVendor", icon: "/U_Bundle.svg" },
          { title: "Create Your Bundle ", path: "/InventoryPlan", icon: "/U_Custom_Plan.svg" },
          { title: "Upload Your Inventory", path: "/InventoryUpload", icon: "/U_Inventory.svg" },


        ],
      },
      { title: "User Role Management", path: "/InventoryCustomer", icon: "/icons3.svg" },

    );
  }

   else if (isPartner) {
    // Menu items for general partners (when isstoredPartnerCode is false)
    firstMenuItems.push(
      { title: "Dashboard", path: "/Home", icon: "/icons.svg" },
      { title: "eSIMs Store", path: "/EsimStore", icon: "/icons1.svg" },
      {title: "Purchase History",path: "/SimMangement",icon: "/icons8.svg"},
      { title: "Wallet Top-Up", path: "/AddmoreBalance", icon: "/icons3.svg" },
      { title: "Transactions", path: "/Transactions", icon: "/icons6.svg" },
     {title: "Top-Up/Renew History",path: "/BuyTopupHistory",icon: "/icons8.svg"},
      { title: "User Role Management", path: "/InventoryCustomer", icon: "/icons3.svg" },
      {
        title: "Create Your Custom Plan",
        path: "/InventoryVendor",
        icon: "/icons1.svg",
        children: [
          { title: "Add Your Vendor", path: "/InventoryVendor", icon: "/U_Bundle.svg" },
          { title: "Create Your Bundle ", path: "/InventoryPlan", icon: "/U_Custom_Plan.svg" },
          { title: "Upload Your Inventory", path: "/InventoryUpload", icon: "/U_Inventory.svg" },


        ],
      },
    //   { title: "User Role Management", path: "/InventoryCustomer", icon: "/icons3.svg" },

    );
  }
  
  
  if (isPayaspergo) {
    firstMenuItems.push(
      { title: "Dashboard", path: "/Home", icon: "/icons.svg" },
      { title: "eSIMs Store", path: "/EsimStore", icon: "/icons1.svg" },
      // { title: "Regional eSIMs Store", path: "/Buydatad", icon: "/icons2.svg" },
      { title: "News & Updates", path: "/News", icon: "/icons4.svg" }
    );
  }
  
  const secondMenuItems = [
    // { title: 'Purchase History', path: '/SimManagement', icon: '/icons8.svg' },
    // Add more second menu items as needed
  ];
  if (isAdmin) {
    secondMenuItems.push(
      {title: "Purchase Details",path: "/SuperadminWallet",icon: "/icons8.svg",},
            {title: "Plan Topup/Renewal",path: "/SuperadminRenewal",icon: "/icons8.svg",},

      
      {title: "Create Partner",path: "/SuperadminPartner",icon: "/icons2.svg",},
      // {title: "SuperadminUpdate List ",path: "/SuperadminVendor",icon: "/icons5.svg",},
      // { title: "Partner Update ", path: "/Superadminpay", icon: "/icons1.svg" },
      { title: "API Box", path: "/ApiBox", icon: "/iconApi.svg" },
      { title: "Tickets", path: "/SuperadminTicket", icon: "/icons7.svg" },
      // { title: "Vendor Lists", path: "/SuperadminUpdate", icon: "/icons4.svg" },

      
    );
  }
  if (isPartner) {
    secondMenuItems.push({ title: "Create Ticket", path: "/CreateTicket", icon: "/icons2.svg" },
    );
  }
  if (isPayaspergo) {
    secondMenuItems.push({title: "Purchase History",path: "/SimMangement",icon: "/icons8.svg",    });
  }
  if (isfinance) {
    secondMenuItems.push( 
       {title: "Purchase Details",path: "/SuperadminWallet",icon: "/icons8.svg",},
       { title: "Tickets", path: "/SuperadminTicket", icon: "/icons7.svg" },

      );
  

  }



  const thirdMenuItems = [
    // { title: 'API Box', path: '/ApiBox', icon: '/iconApi.svg' },
    // { title: 'Help & Support', path: '/HelpSupport', icon: '/icons8.svg' },
    // { title: 'Create Ticket', path: '/CreateTicket', icon: '/icons2.svg' },
    // // Add more third menu items as needed
  ];

  if (isPartner) {
    thirdMenuItems.push(
      { title: "API Box", path: "/ApiBox", icon: "/iconApi.svg" },
      { title: "Help & Support", path: "/HelpSupport", icon: "/iconhelp.svg" },
      { title: "News & Updates", path: "/News", icon: "/icons4.svg" },
      // Add more third menu items as needed
    );
  }
  if (isPayaspergo) {
    thirdMenuItems.push(
      { title: "API Box", path: "/ApiBox", icon: "/icons7.svg" },
      { title: "Help & Support", path: "/HelpSupport", icon: "/iconhelp.svg" },
      { title: "Create Ticket", path: "/CreateTicket", icon: "/icons2.svg" }
      // Add more third menu items as needed
    );
  }

  const renderMenuItem = (menu, index) => {
    const isSelected = location.pathname === menu.path;
    const iconStyle = isSelected
      ? { filter: "invert(100%) brightness(100%)" }
      : {};
      return (
        <Link to={menu.path} key={index}>
          <li
            className={`flex items-center gap-x-3 p-3 text-base relative font-large cursor-pointer  ${
              isSelected ?'bg-[#3E436D] text-white dark:bg-gray-700':"dark:text-white hover:bg-[#dbedec] dark:hover:bg-gray-700"
            }`}
          >
            <div className="w-8 h-8 p-2 rounded-2xl bg-[#3E436D] flex items-center justify-center">
  <img src={menu.icon} alt="" className="w-4 h-4" />
</div>

            <span className={`origin-left duration-300 hover:block`}>{menu.title}</span>
          </li>
        </Link>
      );
    };

    useEffect(() => {
      // Fetch user role from localStorage
      const role = localStorage.getItem("role");
      setUserRole(role);
    }, []);
  
    return (
      <>
        <div     className={` bg-[#ffffff] hidden lg:basis-1/4 xl:basis-1/5 lg:block h-screen sticky top-0 duration-300 rounded-xl m-2  border-4 `}>
  
        <div   className="text-white border border-gray-300 shadow-md rounded-2xl ">
          
         
            <p className="text-black font-bold pb-2 p-6 " style={{fontSize:"22px"}}>{userName}</p>
            <p className="text-white p-2">
  {/* {userRole === 'Partner' && (
    <>
      {walletData ? (
        <span style={{ backgroundColor: '#4cc8c1' }} className="text-4xl font-semibold p-2">
          {`$${walletData.balance}`}
        </span>
      ) : (
        <span className="text-lg text-gray-600">Loading...</span>
      )}
    </>
  )} */}
</p>



          </div>
  
          <ul className='pt-2 overflow-y-auto' style={{ maxHeight: 'calc(60vh - 172px)' }}>
          {firstMenuItems.map((item, idx) => (
            <SideBarMenuItem
              location={location}
              menu={item}
              key={item.path ?? idx}
            />
          ))}
          </ul>
  
          <hr className="my-4 border-gray-400" />
  
          <ul className='pt-2 overflow-y-auto' style={{ maxHeight: 'calc(100vh - 372px)' }}>
          {secondMenuItems.map((item, idx) => (
            <SideBarMenuItem
              location={location}
              menu={item}
              key={item.path ?? idx}
            />
                    ))}          </ul>
  
          <hr className="my-4 border-gray-400" />
  
          <ul className=' overflow-y-auto' style={{ maxHeight: 'calc(100vh - 272px)' }}>
            {thirdMenuItems.map(renderMenuItem)}
          </ul>
        </div>
  
        {/* Mobile Menu */}
        <div className="pt-3 bg-red-400">
          <HamburgerButton
            setMobileMenu={setMobileMenu}
            mobileMenu={mobileMenu}
          />
        </div>
  
        <div className="lg:hidden">
       
       
       <div
  className={`${
    mobileMenu ? 'flex' : 'hidden'
  } absolute z-50 flex-col items-start mt-16 w-full max-w-sm px-6 py-4 space-y-4 bg-gray-50 dark:bg-slate-800 drop-shadow-lg md:rounded-xl font-semibold dark:text-white`}
>
  {[firstMenuItems, secondMenuItems, thirdMenuItems].map((menuGroup, groupIndex) => (
    <section key={groupIndex} className="w-full space-y-2">
      {menuGroup.map((menu, index) => (
        <Link
          to={menu.path}
          key={index}
          onClick={() => setMobileMenu(false)}
          className="block"
        >
          <span
            className={`block w-full px-4 py-2 rounded-lg transition-all duration-200 ${
              location.pathname === menu.path
                ? 'bg-[#3E436D] dark:bg-gray-700 text-white'
                : 'hover:bg-[#3E436D] dark:hover:bg-gray-700'
            }`}
          >
            {menu.title}
          </span>
        </Link>
      ))}

      {/* Divider only between sections */}
      {groupIndex < 2 && <hr className="my-4 border-gray-300 dark:border-gray-600" />}
    </section>
  ))}
</div>


          
        </div>
      </>
    );
  };
  

export default Sidebar;
function SideBarMenuItem({ menu }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Check if the current menu or any of its children is selected
  const isSelected = location.pathname === menu.path;
  const isParentSelected = menu.children && menu.children.some(child => location.pathname === child.path);
  const isSubChildSelected = menu.children && menu.children.some(child => location.pathname === child.path);

  const iconStyle = isSelected || isSubChildSelected
    ? { filter: "invert(100%) brightness(100%)" }
    : {};

  // Toggle the dropdown when clicking the parent
  const handleParentClick = (e) => {
    if (menu.children && menu.children.length) {
      e.preventDefault();
      setOpen(prev => !prev);  // Toggle open state on parent click
    }
  };

  // Close the dropdown if a sub-child is selected
  useEffect(() => {
    if (isSubChildSelected) {
      setOpen(true);  // Open dropdown when a child is selected
    } else if (!isSelected && !isParentSelected) {
      setOpen(false);  // Close dropdown if no sub-child or parent is selected
    }
  }, [location.pathname, isSubChildSelected, isSelected, isParentSelected]);

  return (
    <Link
      to={menu.children && menu.children.length ? "" : menu.path}
      onClick={handleParentClick}
    >
      <div>
        <div
          className={`px-2 ${
            isSelected || isParentSelected
              ? "bg-[#3E436D] text-white dark:bg-gray-700 hover:bg-[#3E436De5]"
              : "dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
          }`}
        >
          <div className="flex items-center justify-between">
            <div
              className={`flex items-center py-2 px-2 gap-2 rounded-md text-base relative cursor-pointer`}
            >
  <div className="w-8 h-8 p-2 rounded-2xl bg-[#3E436D] flex items-center justify-center">
  <img src={menu.icon} alt="" className="w-4 h-4" />
</div>


              <span className={`origin-left duration-300 hover:block`}>
                {menu.title}
              </span>
            </div>
            <span>
              {Array.isArray(menu.children) && menu.children.length && open ? (
                <LuChevronDown className="w-8 h-8 text-inherit" />
              ) : Array.isArray(menu.children) && menu.children.length ? (
                <LuChevronRight className="w-8 h-7 text-inherit" />
              ) : null}
            </span>
          </div>
        </div>
        {open && menu.children && menu.children.length && (
          <div className="flex flex-col gap-2 w-full">
            {menu.children.map((item, idx) => (
              <Link
                key={idx}
                to={item.path}
                className={`pl-16 py-2 w-full flex origin-right gap-2 ${
                  location.pathname === item.path
                    ? "bg-[#3E436D] text-white hover:bg-[#3E436De5]"
                    : "bg-gray-100  hover:bg-gray-400 hover:text-white"
                 }`}
              >
                <img
                  className="w-5 h-5 relative overflow-hidden shrink-0 "
                  alt=""
                  src={item.icon || menu.icon}  // Fallback to parent icon if child doesn't have one
                 
                />
                {item.title}
              </Link>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}
